import { Component, Input } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../../tpv/services";
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the ConfigurationRoomsCreateTablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-partial-rooms-create-name',
    templateUrl: 'configuration-partial-rooms-create-name.html',
})
export class ConfigurationPartialRoomsCreateNamePage {

    @Input() room;
    @Input() update_state: boolean = false;

    @Input() form: FormGroup;
    public form_table: FormGroup;
    public room_uid: any;
    public table: any;
    public room_name: any;
    public order: any;
    map: boolean = false;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        private toastCtrl: ToastController,
        public tpvServices: TPVServices,
        public globals: Globals,
        public translate: TranslateService,
        private alertCtrl: AlertController) {

    }

    submit() {
        if (this.form.valid) {
            if (!this.update_state) {
                this.insert();
            } else {
                this.update();
            }
        } else {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('instant-introduce-nombre-comedor-continuar'),
                duration: 3000,
                position: 'bottom'
            });
            toast.present();
        }
    }

    insert() {
        this.tpvServices.afs.collection('rooms').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'name': this.form.value.name,
            'map': this.form.value.map,
            'order': this.form.value.order,
        }).then(doc => {
            this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Create', this.globals.restaurant.email, 'Create/Update', 'Create room', 'Configuration', this.form.value.name);
            this.navCtrl.pop();
        });
    }

    update() {
        this.tpvServices.afs.collection('rooms').doc(this.room.UID).update({
            'name': this.form.value.name,
            'map': this.form.value.map,
            'order': this.form.value.order,
        }).then(() => {
            this.globals.GAtrackView('Configuration', 'Configuration - Rooms - Update', this.globals.restaurant.email, 'Create/Update', 'Update room', 'Configuration', this.form.value.name);
            this.navCtrl.pop();
        });
    }

    async updateIonToggle() {
        if (this.update_state) {
            this.tpvServices.afs.collection('rooms').doc(this.room.UID).update({
                'map': this.form.value.map,
            }).then(doc => {
                this.room.map = this.form.value.map;
            })
        }

    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-comedor'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.tpvServices.afs.collection('rooms').doc(this.room.UID).delete();
                        //Eliminar todas las mesas de la room eliminada
                        this.tpvServices.firestore.collection('tables').where('UID_RESTAURANT', '==', this.globals.restaurant_uid)
                            .where('uid_room', '==', this.room.UID).get()
                            .then(snapshot => {
                                snapshot.forEach(doc => {
                                    var table = doc.data();
                                    table.UID = doc.id;
                                    this.tpvServices.afs.collection('tables').doc(table.UID).delete();
                                });
                            });;
                        this.navCtrl.pop();
                    }
                }
            ]
        });
        alert.present();

    }


}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rooms/configuration-rooms-create/configuration-partial-rooms-create-name/configuration-partial-rooms-create-name.ts